import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { EmptyStateWrapper, ButtonType } from '@checkmarx/cx-ui';
import SAMLTabs from './tabs';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import SAMLIDPItemsContainer from '../idpItems';
import AddEditSAMLFormContainer from '../addEditForm';
import ServiceProviderForm from '../serviceProviderForm';
import { LdapEditMode } from '../../../services/enums/ldap';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';

@inject('translationsStore', 'samlStore', 'teamsStore') @observer
export default class SAMLTabsContainer extends Component {

    samlStore = this.props.samlStore;
    t = this.props.translationsStore.translate;
    
    state = {
        add: false,
        openLeaveFormDialog: false
    };

    handleActive = tab => {

        this.props.samlStore.setSelectedTabId(tab.props['value']);
    }

    setSelectedTabId = _ => {

        this.props.samlStore.setSelectedTabId(1);
    }

    openLeaveFormDialogHandler = () => {

        if (this.samlStore.isEditMode === true) {
         
            this.setState({ 
                openLeaveFormDialog: true
            });
        }
    }

    leaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false,
            add: false
        });

        this.samlStore.toggleIsEditMode();
        this.samlStore.resetForm();
    }

    stayFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false
        });
    }

    openForm = _ => {
        
        this.setState({
                add: true
            });

        this.samlStore.toggleIsEditMode();
    }

    cancelAdd = _ => this.setState({
                        add: false
                    });

    componentDidMount() {

        this.samlStore.getAllSAMLIdentityProviders()
            .then(saml => {

            });

        this.props.teamsStore.getAllTeams();

        window.SAMLTabsContainer = this;
    }

    render() {

        const t = this.props.translationsStore.translate;
        let identityProviderForm = null;

        if (this.samlStore.samlIdentityProviders === undefined 
                || this.props.teamsStore.teams === undefined) {
            
            identityProviderForm = <div style={{height: '65vh'}}><ScreenLoaderContainer /></div>;
        }
        else {

            if (this.samlStore.samlIdentityProviders.length > 0) {
                
                identityProviderForm = <div
                                style={{padding: '35px 0 0 0'}}
                            >
                                <SAMLIDPItemsContainer
                                    items={this.samlStore.samlIdentityProviders}
                                />
                            </div>;
            }
            else {

                identityProviderForm = this.state.add ? 
                                    <div
                                        className='ldap-add-form-wrapper'
                                        data-cy='saml-add-form-wrapper'
                                        style={{marginTop: 25}}
                                    >
                                        <AddEditSAMLFormContainer
                                            editMode={LdapEditMode.add}
                                            cancelButtonHandler={this.openLeaveFormDialogHandler}
                                            closeForm={this.openLeaveFormDialogHandler}
                                        />
                                    </div>  :
                                                <div
                                                    style={{padding: '35px 0 0 0'}}
                                                >
                                                    <EmptyStateWrapper
                                                        dataCy="add-saml-identity-provider-button"
                                                        onClick={this.openForm}
                                                        text={this.props.translationsStore.translate('ADD_IDENTITY_PROVIDERS')}
                                                    />
                                                </div>;
            }
        }

        const tabs = [
            { 
                id: 1,
                title: t('IDENTITY_PROVIDERS'),
                dataCy: 'saml-identiy-providers-tab',
                component: identityProviderForm
            },
            { 
                id: 2,
                title: t('SERVICE_PROVIDER'),
                dataCy: 'service-provider-tab',
                component: <div style={{marginTop: 15}}>
                                <ServiceProviderForm />
                            </div>
            }
        ];

        return(
            <div>
                <SAMLTabs
                    tabs={tabs}
                    handleActive={this.handleActive}
                    selectedTabId={this.props.samlStore.selectedTabId}
                    setSelectedTabId={this.setSelectedTabId}
                />
                <ConfirmationDialog 
                    open={this.state.openLeaveFormDialog}
                    onButtonClick={this.stayFormDialogHandler}
                    onCancelClick={this.leaveFormDialogHandler}
                    closeClick={this.stayFormDialogHandler}
                    buttonText={t('STAY')}
                    cancelButtonText={t('LEAVE')}
                    titleText={t('CONFIRMATION')}
                    contentText={t('ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_FOR_WITHOUT_SAVING')}
                />
            </div>
        );
    }
}